import LoenserviceHandler, { eSalaryAbsenceStatus } from "@/handlers/loenservice-handler";
import { AbstractJSONModel } from "./master-model";
import { eSalerySystem, Institution } from "./institution-model";

export interface ISalaryRecordPost {
  salary_type_id: number;
  employee_id: number;
  units: number;
  referenced_from_date: Date;
  referenced_to_date: Date;
  sent_date: Date | null;
  created_at: Date;
  updated_at: Date;
  is_system_created: boolean;
}

export interface ISalaryRecordPut {
  id: number;
  salary_type_id: number;
  employee_id: number;
  units: number;
  referenced_from_date: Date;
  referenced_to_date: Date;
}

export interface ISalaryRecord {
  id: number;
  salary_type_id: number;
  employee_id: number;
  units: number;
  referenced_from_date: Date;
  referenced_to_date: Date;
  sent_date: Date | null;
  created_at: Date;
  updated_at: Date;
  is_system_created: boolean;
  status: string;
  status_message: string;
}

export class SalaryRecord extends AbstractJSONModel implements ISalaryRecord {
  public id = -1;
  public salary_type_id = -1;
  public employee_id = -1;
  public units = 0;
  public referenced_from_date: Date = new Date();
  public referenced_to_date: Date = new Date();
  public sent_date: Date | null = null;
  public created_at: Date = new Date();
  public updated_at: Date = new Date();
  public is_system_created = false;
  public status: string = LoenserviceHandler.INITIAL;
  public status_message = "";

  public convertToPostObject(): ISalaryRecordPost {
    const s: ISalaryRecordPost = Object.assign({});
    s.salary_type_id = this.salary_type_id;
    s.employee_id = this.employee_id;
    s.units = this.units;
    s.referenced_from_date = this.referenced_from_date;
    s.referenced_to_date = this.referenced_to_date;
    s.sent_date = this.sent_date;
    s.created_at = this.created_at;
    s.updated_at = this.updated_at;
    s.is_system_created = this.is_system_created;

    return s;
  }

  public convertToPutObject(): ISalaryRecordPut {
    const s: ISalaryRecordPut = Object.assign({});
    s.id = this.id;
    s.salary_type_id = this.salary_type_id;
    s.employee_id = this.employee_id;
    s.units = this.units;
    s.referenced_from_date = this.referenced_from_date;
    s.referenced_to_date = this.referenced_to_date;

    return s;
  }

  getStatus(): eSalaryAbsenceStatus {
    return LoenserviceHandler.getStatus(undefined, this.status);
  }

  equals(other: ISalaryRecord): boolean {
    return other.id === this.id;
  }

  canEdit(): boolean {
    const salerySystem = Institution.getSalerySystem();

    if (salerySystem === eSalerySystem.KMD) {
      const status = LoenserviceHandler.getStatus(undefined, this.status);
      return (status !== eSalaryAbsenceStatus.READY_FOR_DELIVERY) && (status !== eSalaryAbsenceStatus.PENDING) && (status !== eSalaryAbsenceStatus.DELIVERED);
    }
    return true;
  }
}
